<template>
  <!-- 侧边栏：笔记列表 -->
  <div class="sidebar">
    <div class="sidebar-header">
      <h1>曹兵雷</h1>
      <button class="new-note-btn" @click="createNewNote">+</button>
    </div>
    <div class="notes-list">
      <div
        v-for="note in notes"
        :key="note.id"
        class="note-item"
        :class="{ active: currentNoteId === note.id }"
        @click="selectNote(note)"
      >
        <div class="note-title">{{ note.title || '无标题笔记' }}</div>
        <div class="note-time">{{ formatDate(note.time) }}</div>
      </div>
      <div class="empty-tip" v-if="notes.length === 0">
        暂无笔记，点击"+"创建新笔记
      </div>
    </div>
  </div>

  <!-- 主编辑区 -->
  <div class="editor">
    <div class="editor-card">
      <input
        type="text"
        class="title-input"
        v-model="noteTitle"
        placeholder="请输入笔记标题..."
        :disabled="!currentNoteId"
      >
      <textarea
        class="content-textarea"
        v-model="noteContent"
        placeholder="请输入笔记内容..."
        :disabled="!currentNoteId"
      ></textarea>

      <div class="btn-group">
        <button
          class="btn delete-btn"
          @click="deleteNote"
          v-show="currentNoteId"
        >
          删除笔记
        </button>
        <button
          class="btn save-btn"
          @click="saveNote"
          v-show="currentNoteId"
        >
          保存笔记
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from "axios"

// 核心数据
const notes = ref([])
const currentNoteId = ref(null)
const noteTitle = ref('')
const noteContent = ref('')
const userW = ref('曹兵雷') // 固定用户名（可自行修改）

// 页面加载时获取笔记列表
onMounted(() => {
  //boot2()
  var userR=window.sessionStorage.getItem("user") //获取用户名
  console.log(userR+"sess")
  if(userR==="" || userR==null || userR!=="曹兵雷/141023"){
    userR=window.localStorage.getItem("user")
    console.log(userR+"kong")
    if(userR==="" || userR==null || userR!=="曹兵雷/141023") {
      window.location.replace('about:blank')
    }else {
      boot2()
    }
  }else {
    boot2();
  }
  
  // userW=window.sessionStorage.getItem("user") //获取用户名
  //   console.log(userW+"sess")
  //   if(userW==="" || userW==null){
  //       userW=window.localStorage.getItem("user")
  //       console.log(userW+"kong")
  //       if(userW==="" || userW==null) {
  //           //router.push('/login');
  //       }else {
  //           boot2()
  //       }
  //   }else {
  //       boot2();
  //   }
})

// 启动函数
function boot2() {
  axios.get(`/api/text/${userW.value}`).then(res => {
    if (res.data.flag && res.data.data.records.length) {
      notes.value = res.data.data.records
    }
  })
}

// 选中笔记
function selectNote(note) {
  currentNoteId.value = note.id
  noteTitle.value = note.title
  noteContent.value = note.content
}

// 创建新笔记
function createNewNote() {
  if (!userW.value) return
  const json = {
    title: '新建文本文档',
    author: userW.value,
    content: ''
  }
  axios.post('/api/text', json).then(() => {
    boot2()
    resetEditor()
  })
}

// 保存笔记
function saveNote() {
  if (!currentNoteId.value) return
  const json = {
    id: currentNoteId.value,
    title: noteTitle.value,
    author: userW.value,
    content: noteContent.value
  }
  axios.put('/api/text', json).then(() => {
    boot2()
    resetEditor()
  })
}

// 删除笔记
function deleteNote() {
  if (!currentNoteId.value) return
  if (confirm('确定要删除这条笔记吗？删除后无法恢复！')) {
    axios.delete(`/api/text/${userW.value}/${currentNoteId.value}`).then(() => {
      boot2()
      resetEditor()
    })
  }
}

// 清空编辑区
function resetEditor() {
  noteTitle.value = ''
  noteContent.value = ''
  currentNoteId.value = null
}

// 格式化时间
function formatDate(isoString) {
  const date = new Date(isoString)
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}



</script>

<style>

#app {
  display: flex;   /* 左右布局神器 */
  width: 100vw;
  height: 100vh;
}
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft Yahei", sans-serif;
}

body {
  background-color: #f5f5f5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


/* 侧边栏 */
.sidebar {
  width: 260px;
  flex-shrink: 0;  /* 永远不被挤压，页面再小也不变形 */
}

.sidebar-header {
  padding: 16px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidebar-header h1 {
  font-size: 18px;
  color: #333;
}

.new-note-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #409eff;
  color: #fff;
  border: none;
  cursor: pointer;
}

.new-note-btn:hover {
  background-color: #66b1ff;
}

.notes-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.note-item {
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  border-left: 3px solid transparent;
}

.note-item:hover {
  background-color: #f0f9ff;
}

.note-item.active {
  background-color: #e6f7ff;
  border-left-color: #409eff;
}

.note-title {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.note-time {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.empty-tip {
  text-align: center;
  padding: 32px 0;
  color: #999;
}

/* 编辑区 */
.editor {
  flex: 1;  /* 自动占满剩余空间 */
  padding: 16px;
}


.editor-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.title-input {
  padding: 16px 20px;
  border: none;
  outline: none;
  font-size: 20px;
  border-bottom: 1px solid #eee;
}

.content-textarea {
  flex: 1;
  padding: 20px;
  border: none;
  outline: none;
  resize: none;
  font-size: 14px;
  line-height: 1.6;
}

.btn-group {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn {
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}

.delete-btn {
  background-color: #f56c6c;
  color: #fff;
}

.save-btn {
  background-color: #67c23a;
  color: #fff;
}
</style>



